import React, { useEffect, useState, useContext } from 'react';

// SERVICES
import { getHubStatus } from '../services/settingService';

// CONTEXT
import { AuthContext } from '../context/AuthContext';

// COMPONENTS
import Loader from './loaderComponent';

// PAGES
import Maintenance from '../pages/maintenance';
import Updating from '../pages/updating';

const HubStatusCheck = ({ children }) => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const { isAdmin } = useContext(AuthContext);

  useEffect(() => {
    const checkHubStatus = async () => {
      try {
        const response = await getHubStatus();
        const hubStatus = JSON.parse(response.data.hub_status);
        setStatus(hubStatus);
      } catch (error) {
        console.error('Erreur lors de la vérification du statut du hub:', error);
        setStatus({ label: 'maintenance', info: 'Une erreur est survenue lors de la vérification du statut du hub.' });
      } finally {
        setLoading(false);
      }
    };

    checkHubStatus();
    // Vérifier le statut toutes les 30 secondes
    const interval = setInterval(checkHubStatus, 30000);
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <Loader />
    );
  }

  switch (status?.label) {
    case 'maintenance':
      return <Maintenance message={status.info} />;
    case 'updating':
      if (status.admin_only === "true" && isAdmin) {
        return children;
      }
      return <Updating message={status.info} dateEnd={status.date_end} />;
    case 'admin_only':
      return isAdmin ? children : <Maintenance message="L'accès au hub est actuellement réservé aux administrateurs." />;
    case 'on':
      return children;
    default:
      return <Maintenance message="Le hub est actuellement indisponible." />;
  }
};

export default HubStatusCheck; 